import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { navigateToCategory } from "../../../utils/utils";
import Translate from "../../../Components/Multilanguage/Translate";

const Genres = ({ data }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const navigate = useNavigate();
  const [swiperKey, setSwiperKey] = useState(0);
  const [activeIndex, setActiveIndex] = useState("0");
  const swiperRef = useRef(null);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const itemShape = data?.item_shape || "round";
  const imageRequired = data?.image_required;

  const count = data?.length;
  let displayedData = data?.shows;
  const isSingleCard = data?.shows?.length === 1;

  const onSlideChange = (swiper) => {
    const lastSlideIndex =
      swiper.activeIndex + (swiper.params.slidesPerView - 1);

    if (lastSlideIndex >= swiper.slides.length) {
      setActiveIndex(swiper.slides.length - 1);
    } else {
      setActiveIndex(lastSlideIndex);
    }
  };

  const handleSwiperInit = (swiperInstance) => {
    swiperRef.current = swiperInstance;
    onSlideChange(swiperInstance);
  };

  if (isRTL && count > 5) {
    displayedData = [...displayedData].reverse();
  }

  useEffect(() => {
    setSwiperKey((prevKey) => prevKey + 1);
  }, [isRTL]);

  return (
    <div
      className={`gaiaGenresContainer ${
        template === "TEMPLATE_9" ? "template-9" : ""
      } ${isRTL ? (count > 5 ? "ltr" : "rtl") : ""}`}
      style={{
        borderBottomColor:
          projectInfo?.projectConfig?.config?.BACKGROUND_COLOR ||
          "--border-color",
        "--swiper-prev-background": projectInfo?.projectConfig?.config
          ?.BACKGROUND_COLOR
          ? projectInfo?.projectConfig?.config?.BACKGROUND_COLOR
          : "linear-gradient(180deg, rgba(254, 254, 254, 1) 0%, rgba(254, 254, 254, 0.9) 30%, rgba(236, 236, 236, 0.5) 100%)",
      }}
    >
      <div className="wrapper">
        <div className="categoryNameContainerMedium">
          <h1>{data?.category_name || <Translate textKey={"genres"} />}</h1>
        </div>
        <div className="itemsContainer">
          <div className="categoryNameContainer">
            <div className="categoryDetails">
              <h1>{data?.category_name || <Translate textKey={"genres"} />}</h1>
              <span className="seeAll">
                <Translate textKey={"see_all"} /> (
                {data?.shows_count ? data?.shows_count : data?.shows?.length})
              </span>
            </div>
          </div>
          <Swiper
            key={swiperKey}
            modules={[Navigation]}
            spaceBetween={1.5}
            slidesPerView={5}
            slidesPerGroup={5}
            navigation={true}
            onSlideChange={onSlideChange}
            watchSlidesProgress
            loop={false}
            onSwiper={handleSwiperInit}
            initialSlide={isRTL && count > 5 ? count : 0}
            className="items"
            breakpoints={{
              320: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                // spaceBetween: 20,
              },
              481: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                // spaceBetween: 20,
              },
              769: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                // spaceBetween: 20,
              },
              981: {
                slidesPerGroup: 4,
                slidesPerView: 4,
                // spaceBetween: 20,
              },
              1201: {
                slidesPerGroup: 5,
                slidesPerView: 5,
                // spaceBetween: 20,
              },
            }}
          >
            {displayedData?.map((item, index) => (
              <SwiperSlide
                key={index}
                className={`category-slide ${
                  isSingleCard
                    ? ""
                    : index === activeIndex
                    ? "translate-last"
                    : ""
                }`}
              >
                <div
                  className={`category-name ${itemShape}`}
                  onClick={() =>
                    navigateToCategory(navigate, displayedData[index])
                  }
                >
                  {imageRequired && item?.logo ? (
                    <div className={`${itemShape}-container`}>
                      <img
                        src={item?.logo}
                        onError={(e) => {
                          e.target.src =
                            projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE;
                        }}
                        alt="Banner"
                      />
                    </div>
                  ) : (
                    <div className={`${itemShape}-container placeholder`}>
                      <h1 className="placeholder-text">
                        {item?.category_name}
                      </h1>
                    </div>
                  )}
                  <div
                    className={`genre-name ${
                      template === "TEMPLATE_10"
                        ? "gaia"
                        : template === "TEMPLATE_9"
                        ? "template_9"
                        : ""
                    }`}
                  >
                    {item?.category_name}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Genres;
